const wowApp = require('angular').module('wowApp.shop');
wowApp.directive('wowToggle', [require('./toggle-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/toggle/index.js
 **/